import React, { useState } from 'react';
import cx from 'classnames';

import Card from '@marketing/components/card';
import SectionHeader from '@marketing/components/section_header';

import AICoachingFeature from './assets/ai_coaching_feature.png';
import AIExplanationsFeature from './assets/ai_explanations_feature.png';
import AISpeakingGradingFeature from './assets/ai_speaking_grading_feature.png';
import AIWritingGradingFeature from './assets/ai_writing_grading_feature.png';
import ETSBadge from './assets/ets_badge.svg';
import SparkleBg from './assets/sparkle_bg.svg';
import SparkleIcon from './assets/sparkle_icon.svg';
import marketingStyles from '@marketing/style.module.scss';
import styles from './style.module.scss';

export default (props) => {
  const [selectedAIGraderValueProp, setSelectedAIGraderValueProp] = useState('writing');

  return (
    <div className="d-flex flex-column gap-l u-margin-T-xl" style={{ position: 'relative' }}>
      <SparkleBackground />

      <SectionHeader
        reveal
        subtitle="Get instant, TOEFL-style speaking & writing scoring with personalized feedback, chat with an expert AI tutor, and practice with Magoosh."
        supertitle="AI test prep"
        supertitleIcon={SparkleIcon}
        title="Study smarter with AI"
      />

      <div className={cx(styles.aiFeaturesContainer, 'd-flex flex-column gap-m gap-lg-l')}>
        <div className="d-flex flex-column flex-lg-row gap-m gap-lg-l">
          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of helpful conversations with the AI tutor"
                loading="lazy"
                src={AIExplanationsFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                AI Tutor Explanations
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Chat with an AI expert trained on lessons and content and ready to explain whatever you don’t grasp.
              </div>
            </div>
          </Card>

          <Card className="d-flex flex-1 flex-column gap-m">
            <div>
              <img
                alt="Examples of helpful conversations with the AI tutor"
                loading="lazy"
                src={AICoachingFeature}
              />
            </div>

            <div className="d-flex flex-column gap-s">
              <div className="text-bold text-inter">
                AI Tutor Coaching
              </div>

              <div className="text-inter" style={{ fontSize: 15 }}>
                Our AI Tutor analyzes your performance and provides personalized recommendations on how to best improve your score.
              </div>
            </div>
          </Card>
        </div>

        <Card className="d-flex flex-1 flex-column flex-lg-row-reverse gap-m">
          <div>
            <img
              alt="Examples of AI detailed speaking grading"
              loading="lazy"
              src={AISpeakingGradingFeature}
              style={{ display: selectedAIGraderValueProp === 'speaking' ? 'block' : 'none' }}
            />
            <img
              alt="Examples of AI detailed writing grading"
              loading="lazy"
              src={AIWritingGradingFeature}
              style={{ display: selectedAIGraderValueProp === 'writing' ? 'block' : 'none' }}
            />
          </div>

          <div className="d-flex flex-column gap-s">
            <div className="align-items-center d-flex gap-s">
              <div><img alt="ETS logo" src={ETSBadge} width="40" /></div>
              
              <div className="text-bold text-inter">
                AI Speaking & Writing Grader
              </div>
            </div>

            <div className="text-inter" style={{ fontSize: 15 }}>
              Your answers are scored using the official TOEFL® grader, so you'll know exactly what it takes to hit your target score.
            </div>

            <div className="d-flex flex-column u-margin-T-s u-padding-L-xs">
              <div
                className="text-inter text-medium u-padding-L-s u-padding-V-xxs"
                onClick={() => setSelectedAIGraderValueProp('writing')}
                style={{
                  borderColor: selectedAIGraderValueProp === 'writing' ? '#000000' : '#EDEDED',
                  borderStyle: 'solid',
                  borderWidth: '0 0 0 1px',
                  color: selectedAIGraderValueProp === 'writing' ? '#5C5C5C' : '#ADADAD',
                  cursor: selectedAIGraderValueProp === 'writing' ? 'initial' : 'pointer'
                }}
              >
                Writing Grading
              </div>

              <div
                className="text-inter text-medium u-padding-L-s u-padding-V-xxs"
                onClick={() => setSelectedAIGraderValueProp('speaking')}
                style={{
                  borderColor: selectedAIGraderValueProp === 'speaking' ? '#000000' : '#EDEDED',
                  borderStyle: 'solid',
                  borderWidth: '0 0 0 1px',
                  color: selectedAIGraderValueProp === 'speaking' ? '#5C5C5C' : '#ADADAD',
                  cursor: selectedAIGraderValueProp === 'speaking' ? 'initial' : 'pointer'
                }}
              >
                Speaking Grading
              </div>
            </div>
          </div>
        </Card>
      </div>

      <div className="u-margin-T-xl">
        <SparkleBackground mirror />
      </div>
    </div>
  );
};

const SparkleBackground = ({ mirror = false }) => {
  return (
    <>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, transparent, #F2E9FB 30%, #FCECF7 70%, transparent)',
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -3
        }}
      />
      <div
        style={{
          bottom: mirror ? -75 : 'initial',
          height: 300,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          transform: mirror ? 'scaleX(-1) scaleY(-1)' : '',
          width: '100%',
          zIndex: -2
        }}
      >
        <img alt="" src={SparkleBg} />
      </div>
      <div
        className={marketingStyles.fullPageWidthContainerBreakout}
        style={{
          background: 'linear-gradient(to bottom, #fff, transparent 50%, #fff)',
          bottom: mirror ? -75 : 'initial',
          height: 310,
          position: 'absolute',
          top: mirror ? 'initial' : -75,
          zIndex: -1
        }}
      />
    </>
  );
};
